<p-dropdown
  [id]="inputId"
  [filter]="true"
  autoWidth="false"
  [style]="{ width: '100%' }"
  appendTo="body"
  [options]="serviceOptions"
  [ngModel]="serviceId"
  (ngModelChange)="onServiceIdChange($event)"
  optionLabel="label"
  optionValue="value"
  [showClear]="true"
  [loading]="loading"
  [placeholder]="placeholder"
>
  <ng-template pTemplate="selectedItem" let-selectedOption>
    <div class="flex align-items-center gap-2">
      <div>
        <small>Service #{{ selectedOption.value }}</small>
        @if (serviceMap[selectedOption.value]) {
          <br />
          {{ serviceMap[selectedOption.value].ServiceDescription }}
          <br />
          <small>
            {{ serviceMap[selectedOption.value].Date | date : "MM/dd/yyyy" }}
            {{ serviceMap[selectedOption.value].StartTime | date : "HH:mm" }}
            - {{ serviceMap[selectedOption.value].EndTime | date : "HH:mm" }}
            | {{ serviceMap[selectedOption.value].StaffNames?.join(", ") }}
          </small>
        }
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="item" let-option>
    <div>
      <small>Service #{{ option.value }}</small>
      @if (serviceMap[option.value]) {
        <br />
        {{ serviceMap[option.value].ServiceDescription }}
        <br />
        <small>
          {{ serviceMap[option.value].Date | date : "MM/dd/yyyy" }}
          {{ serviceMap[option.value].StartTime | date : "HH:mm" }}
          - {{ serviceMap[option.value].EndTime | date : "HH:mm" }}
          | {{ serviceMap[option.value].StaffNames?.join(", ") }}
        </small>
      }
    </div>
  </ng-template>
</p-dropdown>
